import React from 'react';

interface TopNavBarProps {
  title: string;
  subtitle?: string;
  onBack?: () => void;
}

const TopNavBar: React.FC<TopNavBarProps> = ({ title, subtitle, onBack }) => {
  const handleGoToEditor = () => {
    window.location.href = '/';
  };

  return (
    <div
      style={{
        backgroundColor: '#173647',
        width: '100%',
        height: '54px',
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px',
        gap: '16px',
        flexShrink: 0,
      }}
    >
      {/* Swagger Editor link */}
      <button
        onClick={handleGoToEditor}
        style={{
          background: 'none',
          border: '1px solid rgba(255,255,255,0.3)',
          borderRadius: '4px',
          color: '#fff',
          padding: '6px 12px',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: 500,
          whiteSpace: 'nowrap',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.borderColor = 'rgba(255,255,255,0.6)';
          e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.borderColor = 'rgba(255,255,255,0.3)';
          e.currentTarget.style.background = 'none';
        }}
      >
        Swagger Editor
      </button>

      {/* Divider */}
      <div style={{ width: '1px', height: '24px', background: 'rgba(255,255,255,0.2)' }} />

      {/* Back button (when navigating within Figma Annotator) */}
      {onBack && (
        <button
          onClick={onBack}
          style={{
            background: 'none',
            border: 'none',
            color: 'rgba(255,255,255,0.7)',
            cursor: 'pointer',
            fontSize: '14px',
            padding: '4px 8px',
          }}
          onMouseEnter={e => { e.currentTarget.style.color = '#fff'; }}
          onMouseLeave={e => { e.currentTarget.style.color = 'rgba(255,255,255,0.7)'; }}
        >
          &larr;
        </button>
      )}

      {/* Title */}
      <span style={{ color: '#fff', fontSize: '16px', fontWeight: 600 }}>
        {title}
      </span>

      {/* Subtitle */}
      {subtitle && (
        <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px', fontWeight: 400 }}>
          {subtitle}
        </span>
      )}
    </div>
  );
};

export default TopNavBar;
